/**
 * CONSTANT: Translations
 * @type {Object}
 *
 * This constant contains all of the disclaimer data for display within the application.
 * It"s constructed as a JSON object, which can be used by both Vue and PDFMake.js
 */

const translations = {

	// App
	"toolbar.currentClient" : {
		"en": "Current Client:",
		"fr": "Client actuel : "
	},

	"toolbar.currentView" : {
		"en": "Current View:",
		"fr": "Affichage actuel :"
	},
	"toolbar.clientPanelButton" : {
		"en": "Client Panel",
		"fr": "Tableau du client :"
	},
	"toolbar.clientLoadButton" : {
		"en": "Load Client",
		"fr": "Chargement du client"
	},
	"toolbar.printButton" : {
		"en": "Print",
		"fr": "Impression"
	},
	"toolbar.toolsButton" : {
		"en": "Tools",
		"fr": "Outils"
	},
	"toolbar.settingsButton" : {
		"en": "Settings",
		"fr": "Paramètres"
	},
	"toolbar.logoutButton" : {
		"en": "Log Out",
		"fr": "Fermer la session"
	},	
	"working.text" : {
		"en": "Working",
		"fr": "En attente"
	},


	// Welcome Screen
	"welcome.introQuestion" : {
		"en": "Welcome! What do you want to do today?",
		"fr": "Bienvenue! Que voulez-vous faire aujourd'hui?"
	},
	"welcome.introLoad" : {
		"en": "Awesome! Please use the Client Load<br> tool to load existing client data.",
		"fr": "D’accord! Veuillez utiliser l’outil <br> de chargement du client pour charger les données existantes du client."
	},
	"welcome.add" : {
		"en": "Add a New Client",
		"fr": "Ajouter un nouveau client"
	},
	"welcome.load" : {
		"en": "Load an Existing Client",
		"fr": "Charger un client existant"
	},


	// Client Selector
	"clientSelector.search" : {
		"en": "Search",
		"fr": "Chercher"
	},
	"clientSelector.activeClients" : {
		"en": "Active Clients",
		"fr": "Clients actifs"
	},
	"clientSelector.inactiveClients" : {
		"en": "Inactive Clients",
		"fr": "Clients inactifs"
	},
	"clientSelector.clientBase" : {
		"en": "Client",
		"fr": "Client"
	},


	// Reports
	"report.netWorth" : {
		"en": "Net Worth",
		"fr": "Valeur nette"
	},
	"report.retirementPlanner" : {
		"en": "Retirement Planner",
		"fr": "Planificateur de retraite"
	},
	"report.financialGPS" : {
		"en": "Financial GPS",
		"fr": "GPS financier"
	},
	"report.load" : {
		"en": "Dev",
		"fr": "Outils de développement"
	},


	// Panels
	"panel.save" : {
		"en": "Save",
		"fr": "Enregistrer"
	},
	"panel.disclaimers" : {
		"en": "Disclaimers",
		"fr": "Avis de non-responsabilité"
	},
	"panel.selectClient" : {
		"en": "Select a Client",
		"fr": "Sélectionner un client"
	},
	"panel.clientDetails" : {
		"en": "Client Details",
		"fr": "Détails du client"
	},
	"panel.clientDeactivate" : {
		"en": "Deactivate Client",
		"fr": "Désactiver le client"
	},
	"panel.firstName" : {
		"en": "First Name",
		"fr": "Prénom"
	},
	"panel.lastName" : {
		"en": "Last Name",
		"fr": "Nom de famille"
	},
	"panel.dob" : {
		"en": "Date of Birth",
		"fr": "Date de naissance"
	},
	"panel.gender" : {
		"en": "Gender",
		"fr": "Sexe"
	},
	"panel.maritalStatus" : {
		"en": "Marital Status",
		"fr": "État civil"
	},
	"panel.spouse" : {
		"en": "Spouse",
		"fr": "Conjoint(e)"
	},
	"panel.source" : {
		"en": "Source",
		"fr": "Source"
	},
	"panel.address" : {
		"en": "Address",
		"fr": "Adresse"
	},
	"panel.homePhone" : {
		"en": "Home Phone",
		"fr": "Téléphone à domicile"
	},
	"panel.workPhone" : {
		"en": "Work Phone",
		"fr": "Téléphone au travail"
	},
	"panel.cellPhone" : {
		"en": "Cell Phone",
		"fr": "Téléphone cellulaire"
	},
	"panel.faxNumber" : {
		"en": "Fax Number",
		"fr": "Numéro de télécopieur"
	},
	"panel.email" : {
		"en": "Email",
		"fr": "Courriel"
	},
	"panel.occupation" : {
		"en": "Occupation",
		"fr": "Profession"
	},
	"panel.employer" : {
		"en": "Employer",
		"fr": "Employeur"
	},
	"panel.employerAddress" : {
		"en": "Employer Address",
		"fr": "Adresse de l'employeur"
	},
	"panel.age" : {
		"en": "Age",
		"fr": "Âge"
	},		
	"panel.clientBeneficiary" : {
		"en": "Beneficiary",
		"fr": "Bénéficiaire"
	},
	"panel.clientExecutor" : {
		"en": "Executor",
		"fr": "Exécuteur testamentaire"
	},	
	"panel.incomeDetails" : {
		"en": "Income Details",
		"fr": "Détails du revenu"
	},
	"panel.presentIncome" : {
		"en": "Present Yearly Income",
		"fr": "Revenu annuel actuel"
	},	
	"panel.incomeOtherSources" : {
		"en": "Yearly Income From Other Sources",
		"fr": "Revenu annuel provenant d'autres sources"
	},	
	"panel.pension" : {
		"en": "Pension",
		"fr": "Pension"
	},
	"panel.pensionAge" : {
		"en": "Start Receiving Pension at Age",
		"fr": "Commencer à recevoir une pension à l'âge de"
	},
	"panel.indexPension" : {
		"en": "Index Pension at",
		"fr": "Indexer la pension à"
	},
	"panel.pensionBenefit" : {
		"en": "Pension Benefit at Retirement",
		"fr": "Prestations de retraite à la retraite"
	},
	"panel.cppIntegrate" : {
		"en": "Integrate with CPP",
		"fr": "Intégrer au RPC"
	},
	"panel.hasBridgeBenefit" : {
		"en": "Pension Has a Bridge Benefit",
		"fr": "La pension comporte une prestation de raccordement"
	},					
	"panel.indexPension" : {
		"en": "Index Pension at",
		"fr": "Indexer la pension à"
	},
	"panel.pensionBenefit" : {
		"en": "Pension Benefit at Retirement",
		"fr": "Prestations de retraite à la retraite"
	},
	"panel.cppIntegrate" : {
		"en": "Integrate with CPP",
		"fr": "Intégrer au RPC"
	},
	"panel.hasBridgeBenefit" : {
		"en": "Pension Has a Bridge Benefit",
		"fr": "La pension comporte une prestation de raccordement"
	},	
	"panel.bridgeValue" : {
		"en": "Bridge Benefit Value",
		"fr": "Valeur de la prestation de raccordement"
	},
	"panel.bridgeStart" : {
		"en": "Bridge Benefit Start Age",
		"fr": "Âge de début des prestations de raccordement"
	},
	"panel.bridgeEnd" : {
		"en": "Bridge Benefit End Age",
		"fr": "Âge de fin des prestations de raccordement"
	},
	"panel.cppTitle" : {
		"en": "Canadian Pension Plan (CPP)",
		"fr": "Régime de pensions du Canada (RPC)"
	},	
	"panel.cppAtAge" : {
		"en": "Start Receiving CPP at Age",
		"fr": "Commencer à recevoir des prestations du RPC à l'âge de"
	},
	"panel.cppIndex" : {
		"en": "Index CPP at",
		"fr": "Indexer les prestations du RPC à"
	},
	"panel.cppCustomValue" : {
		"en": "Use a Custom CPP Value (Overrides Constant)",
		"fr": "Utiliser une valeur personnalisée des prestations du RPC (remplace la valeur constante)"
	},
	"panel.cppValue" : {
		"en": "Custom CPP Value",
		"fr": "Valeur personnalisée des prestations du RPC"
	},
	"panel.oasTitle" : {
		"en": "Old Age Security (OAS)",
		"fr": "Sécurité de la vieillesse (SV)"
	},	
	"panel.oasAtAge" : {
		"en": "Start Receiving OAS at Age",
		"fr": "Commencer à recevoir des prestations de SV à l'âge de"
	},
	"panel.oasIndex" : {
		"en": "Index OAS at",
		"fr": "Indexer les prestations de SV à"
	},
	"panel.oasCustomValue" : {
		"en": "Use a Custom OAS Value (Overrides Constant)",
		"fr": "Utiliser une valeur personnalisée des prestations de SV (remplace la valeur constante)"
	},
	"panel.oasValue" : {
		"en": "Custom OAS Value",
		"fr": "Valeur personnalisée des prestations de SV"
	},
	"panel.generalTitle" : {
		"en": "General Retirement Information",
		"fr": "Renseignements généraux sur la retraite"
	},
	"panel.retireAge" : {
		"en": "Age to Retire",
		"fr": "Âge de la retraite"
	},
	"panel.useRetirementDate": {
		"en": "Use Date of Retirement",
		"fr": "Utiliser la date de la retraite"
	},	
	"panel.retirementDate": {
		"en": "Date of Retirement",
		"fr": "Date de la retraite"
	},		
	"panel.perentageIncome" : {
		"en": "Percentage of income required at retirement",
		"fr": "Pourcentage du revenu requis à la retraite"
	},	
	"panel.passiveRetireAge" : {
		"en": "Age of Passive Retirement",
		"fr": "Âge de la retraite passive"
	},
	"panel.percentagePassiveIncome" : {
		"en": "Percentage of income required in passive retirement",
		"fr": "Pourcentage du revenu requis pour la retraite passive"
	},
	"panel.lifeExpectancy" : {
		"en": "Estimated life expectancy",
		"fr": "Espérance de vie estimée"
	},
	"panel.estateTarget" : {
		"en": "Target Value of Estate",
		"fr": "Valeur cible de la succession"
	},
	"panel.inflationRate" : {
		"en": "Average inflation rate",
		"fr": "Taux d'inflation moyen"
	},				
	"panel.retirementPlanTitle" : {
		"en": "Retirement Plan",
		"fr": "Régime de retraite"
	},
	"panel.startPlanIn" : {
		"en": "Start Plan in",
		"fr": "Démarrer le plan dans"
	},	
	"panel.withdrawalOrder" : {
		"en": "Withdrawal Order",
		"fr": "Ordre de retrait"
	},	
	"panel.automaticShortfalls" : {
		"en": "Automatically Fill in Shortfalls",
		"fr": "Combler automatiquement les manques à gagner"
	},
	"panel.percentagefromSavings" : {
		"en": "% Income from Savings",
		"fr": "% du revenu provenant de l'épargne"
	},
	"panel.percentagefromLockedin" : {
		"en": "% Income from Locked-In",
		"fr": "% du revenu provenant de CRI"
	},
	"panel.percentagefromTFSA" : {
		"en": "% Income from TFSA",
		"fr": "% du revenu provenant d'un CELI"
	},
	"panel.percentagefromRegistered" : {
		"en": "% Income from Registered",
		"fr": "% du revenu provenant d'un placement enregistré"
	},	


	// Panel - Savings
	"panel.useMinMax" : {
		"en": "Account for Min/Max",
		"fr": false
	},
	"panel.nonregisteredTitle" : {
		"en": "Non-Registered Investment & Savings",
		"fr": "Placement et épargne non enregistrés"
	},	
	"panel.tfsaTitle" : {
		"en": "Tax-Free Savings Account",
		"fr": "Compte d'épargne libre d'impôt"
	},		
	"panel.registeredTitle" : {
		"en": "Registered Investments",
		"fr": "Placements enregistrés"
	},	
	"panel.dpspTitle" : {
		"en": "DPSP",
		"fr": "RPDB"
	},	
	"panel.otherTitle" : {
		"en": "Other Retirement Savings",
		"fr": "Autres formes d'épargne-retraite"
	},	
	"panel.annualValuesTitle" : {
		"en": "Annual Values over Time",
		"fr": "Valeurs annuelles au fil du temps"
	},	
	"panel.adjustedContributions" : {
		"en": "Adjusted Contributions",
		"fr": "Valeurs annuelles au fil du temps"
	},
	"panel.adjustedWithdrawals" : {
		"en": "Adjusted Withdrawals",
		"fr": "Valeurs annuelles au fil du temps"
	},							
	"panel.chequingAccounts" : {
		"en": "Chequing Accounts",
		"fr": "Comptes de chèques"
	},
	"panel.savingsAccounts" : {
		"en": "Savings Accounts",
		"fr": "Comptes d'épargne"
	},
	"panel.stocks" : {
		"en": "Stocks",
		"fr": "Actions"
	},
	"panel.mutualFunds" : {
		"en": "Mutual Funds",
		"fr": "Fonds communs de placement"
	},
	"panel.other" : {
		"en": "Other",
		"fr": "Autre"
	},	
	"panel.tfsa" : {
		"en": "Tax-Free Savings Accounts",
		"fr": "Compte d'épargne libre d'impôt"
	},
	"panel.rrif" : {
		"en": "RRIFs",
		"fr": "FERR"
	},
	"panel.dpsp" : {
		"en": "DPSP/ESOP/GRSP",
		"fr": "RPDB/RADE/RERC"
	},
	"panel.employerPensionPlan" : {
		"en": "Employer Pension Plan",
		"fr": "Régime de retraite de l'employeur"
	},
	"panel.rrsp" : {
		"en": "Locked-in RRSP",
		"fr": "CRI"
	},
	"panel.annualValues" : {
		"en": "Annual Values",
		"fr": "Valeurs annuelles"
	},


	// Panel = Assets
	"panel.realEstateTitle" : {
		"en": "Real Estate",
		"fr": "Immobilier"
	},	
	"panel.businessInterestsTitle" : {
		"en": "Business Interests",
		"fr": "Intérêts commerciaux"
	},		
	"panel.otherAssetsTitle" : {
		"en": "Other Assets",
		"fr": "Autres actifs"
	},	
	"panel.personalHomes" : {
		"en": "Personal Homes",
		"fr": "Maisons personnelles"
	},
	"panel.otherRealEstate" : {
		"en": "Other Real Estate",
		"fr": "Autres biens immobiliers"
	},
	"panel.businessInterests" : {
		"en": "Business Interests",
		"fr": "Intérêts commerciaux"
	},
	"panel.taxDeferredAssets" : {
		"en": "Tax Deferred Assets",
		"fr": "Actifs d'impôts différés"
	},
	"panel.otherAssets" : {
		"en": "Other Assets",
		"fr": "Autres actifs"
	},


	// Panel - Debt
	"panel.shortTermDebtTitle" : {
		"en": "Short Term Debt",
		"fr": "Dette à court terme"
	},	
	"panel.longTermDebtTitle" : {
		"en": "Long Term Debt",
		"fr": "Dette à long terme"
	},		
	"panel.creditCards" : {
		"en": "Credit Cards",
		"fr": "Cartes de crédit"
	},
	"panel.carLoans" : {
		"en": "Car Loans",
		"fr": "Prêts-autos"
	},
	"panel.lineOfCredit" : {
		"en": "Line of Credit",
		"fr": "Marge de crédit"
	},
	"panel.otherDebts" : {
		"en": "Other Debts",
		"fr": "Autres dettes"
	},
	"panel.homeMortgage" : {
		"en": "Mortgage on Home",
		"fr": "Hypothèque sur la maison"
	},
	"panel.otherMortgages" : {
		"en": "Other Mortgages",
		"fr": "Autres prêts hypothécaires"
	},
	"panel.investmentLoans" : {
		"en": "Investment Loans",
		"fr": "Prêts à l'investissement"
	},		



	// Panel - Insurance
	"panel.lifeInsuranceTitle" : {
		"en": "Life Insurance",
		"fr": "Assurance vie"
	},	
	"panel.lifeInsuranceNeedsTitle" : {
		"en": "Life Insurance Needs",
		"fr": "Besoins d'assurance vie"
	},		
	"panel.cashRequiredTitle" : {
		"en": "Cash Required",
		"fr": "Liquidités requises"
	},		
	"panel.insuranceCashValueTitle" : {
		"en": "Insurance Cash Value",
		"fr": "Valeur de rachat de l'assurance"
	},		
	"panel.capitalGainsTitle" : {
		"en": "Capital Gains",
		"fr": "Gains en capital"
	},		
	"panel.insuranceGroup" : {
		"en": "Group",
		"fr": "Groupe"
	},
	"panel.lifeInsurance" : {
		"en": "Life Insurance",
		"fr": "Assurance vie"
	},
	"panel.employerLifeInsurance" : {
		"en": "Employer Life Insurance",
		"fr": "Assurance-vie de l'employeur"
	},
	"panel.mortgageInsurance" : {
		"en": "Mortgage Insurance",
		"fr": "Assurance hypothécaire"
	},
	"panel.funeralExpenses" : {
		"en": "Funeral Expenses",
		"fr": "Frais funéraires"
	},
	"panel.estateFees" : {
		"en": "Probate, Executor, Legal, Accounting Fees",
		"fr": "Frais d'homologation, d'exécuteur testamentaire, juridiques et comptables"
	},
	"panel.shortTermLivingExpenses" : {
		"en": "Short Term Living Expenses",
		"fr": "Frais de subsistance à court terme"
	},	
	"panel.postSecondaryExpenses" : {
		"en": "Post Secondary Education for Children",
		"fr": "Éducation postsecondaire pour les enfants"
	},
	"panel.lifeInsuranceCashValue" : {
		"en": "Life Insurance Cash Value",
		"fr": "Valeur de rachat de l'assurance vie"
	},
	"panel.adjustedCostRealEstate" : {
		"en": "Adjusted Cost Basis of Real Estate",
		"fr": "Prix de base rajusté des biens immobiliers"
	},	
	"panel.taxableCapitalGains" : {
		"en": "Taxable Portion of Capital Gains",
		"fr": "Partie imposable des gains en capital"
	},	


	// Panel - Snapshots
	"panel.snapshotsTitle" : {
		"en": "Switch to French",
		"fr": "Passer au anglais"
	},	
	"panel.takeSnapshot" : {
		"en": "Take Snapshot",
		"fr": "Prendre un instantané"
	},
	"panel.useCurrentData" : {
		"en": "Use Current Data",
		"fr": "Utiliser les données actuelles"
	},
	"panel.snapshotInstructionIntro" : {
		"en": "You are currently viewing the data snapshots associated with ",
		"fr": "Utiliser les données actuelles"
	},
	"panel.snapshotInstructionGPS" : {
		"en": "the <b>Financial GPS</b> report",
		"fr": "au rapport de <b>GPS financier</b>"
	},
	"panel.snapshotInstructionPlanner" : {
		"en": "the <b>Net Worth</b> and <b>Retirement Planner</b> reports",
		"fr": "au rapport sur la <b>valeur nette </b> et au rapport du <b>planificateur de retraite </b>"
	},


	// Panel - Tools
	"panel.toolsTitle" : {
		"en": "Tools",
		"fr": "Outils"
	},
	"panel.toolSavingsFuture" : {
		"en": "Savings Required for Future",
		"fr": "Économies nécessaires pour l'avenir"
	},
	"panel.toolFutureValue" : {
		"en": "Future Value of an Investment",
		"fr": "Valeur future d'un placement"
	},
	"panel.toolRegularWithdrawals" : {
		"en": "Regular Withdrawals from an Investment",
		"fr": "Retraits réguliers d'un placement"
	},
	"panel.toolSystematicWithdrawals" : {
		"en": "Systematic Withdrawals from an Investment",
		"fr": "Retraits systématiques d'un placement"
	},

				
	// Panel - Settings
	"panel.applicationLanguageTitle" : {
		"en": "Application Language",
		"fr": "Langue de l'application"
	},
	"panel.constantsTitle" : {
		"en": "Constants",
		"fr": "Constantes"
	},
	"panel.disasterTitle" : {
		"en": "Disaster",
		"fr": "Catastrophe"
	},
	"panel.printOptionsTitle" : {
		"en": "Print Options",
		"fr": "Options d'impression"
	},
	"panel.languageSwitcherButton" : {
		"en": "Switch to French",
		"fr": "Passer au anglais"
	},
	"panel.languageSwitcherText" : {
		"en": "The application is currently being rendered in English",
		"fr": "L'application est actuellement en cours de rendu en français"
	},	
	"panel.constantCurrentYear" : {
		"en": "Current Year",
		"fr": "Année en cours"
	},
	"panel.constantMaximumOasPayout" : {
		"en": "Maximum Monthly OAS Payout",
		"fr": "Prestations mensuelles maximales de la SV"
	},
	"panel.constantMaximumOasIncomeThreshold" : {
		"en": "Maximum OAS Income Threshold",
		"fr": "Prestations mensuelles maximales de la SV"
	},
	"panel.constantMaximumCppPayout" : {
		"en": "Maxmium CPP Payout",
		"fr": "Prestations maximales du RPC"
	},
	"panel.constantMaximumCppIncomeThreshold" : {
		"en": "Maximum CPP Income Threshold",
		"fr": "Prestations maximales du RPC"
	},
	"panel.constantCppDeathBenefit" : {
		"en": "CPP Death Benefit",
		"fr": "Prestation de décès du RPC"
	},
	"panel.constantSurvivorPension" : {
		"en": "Survivor's Pension",
		"fr": "Pension de survivant"
	},
	"panel.constantLifSchedule" : {
		"en": "LIF Schedule",
		"fr": "Calendrier des retraits du FRV"
	},
	"panel.shockEvents" : {
		"en": "Shock Events",
		"fr": "Événements perturbés par des chocs négatifs"
	},
	"panel.defaultPrintTitle" : {
		"en": "Default Title",
		"fr": "Titre par défaut"
	},
	"panel.defaultPrintTitleFr" : {
		"en": "Default Title (French)",
		"fr": "Titre par défaut (Français)"
	},

	// Tools
	"tool.monthlyInvestment" : {
		"en": "Investment Required",
		"fr": "Investissement requis"
	},
	"tool.regularWithdrawals" : {
		"en": "First Year %s Withdrawal:",
		"fr": "% de retrait la première année :"
	},	
	"tool.futureValue" : {
		"en": "Future value:",
		"fr": "Valeur future :"
	},	
	"tool.year" : {
		"en": "Year",
		"fr": "Année"
	},
	"tool.period" : {
		"en": "Period",
		"fr": "Période"
	},
	"tool.regularDeposits" : {
		"en": "Regular Deposits",
		"fr": "Dépôts réguliers"
	},
	"tool.totalInvested" : {
		"en": "Total Invested",
		"fr": "Total investi"
	},
	"tool.totalContributions" : {
		"en": "Total Contributions",
		"fr": "Total investi"
	},	
	"tool.gain" : {
		"en": "Gain",
		"fr": "Gain"
	},
	"tool.balance" : {
		"en": "Balance",
		"fr": "Solde"
	},	
	"tool.remainingBalance" : {
		"en": "Remaining Balance*",
		"fr": "Solde restant*"
	},
	"tool.withdrawal" : {
		"en": "Withdrawal",
		"fr": "Retrait"
	},		
	"tool.value" : {
		"en": "Value",
		"fr": "Valeur"
	},
	"tool.sumToAccumulate" : {
		"en": "Sum to Accumulate",
		"fr": "Somme à accumuler"
	},
	"tool.initialInvestment" : {
		"en": "Initial investment",
		"fr": "Investissement initial"
	},
	"tool.initialValue" : {
		"en": "Initial value",
		"fr": "Valeur initiale"
	},	
	"tool.atRateOf" : {
		"en": "At the rate of",
		"fr": "Au taux de"
	},
	"tool.indexAt" : {
		"en": "Index at",
		"fr": "Indexer à"
	},	
	"tool.growthRate" : {
		"en": "Growth rate",
		"fr": "Taux de croissance"
	},	
	"tool.numberOfYears" : {
		"en": "Number of Years",
		"fr": "Nombre d'années"
	},
	"tool.Depositing" : {
		"en": "Depositing",
		"fr": "Dépôt"
	},
	"tool.showSummaryTable" : {
		"en": "Show Summary Table",
		"fr": "Afficher le tableau récapitulatif"
	},
	"tool.withdrawing" : {
		"en": "Withdrawing",
		"fr": "Retrait"
	},
	"tool.withdrawalAmount" : {
		"en": "Withdrawal Amount",
		"fr": "Montant de retrait"
	},	
	"tool.withdrawlsFootnote" : {
		"en": "* Approximate balance, including pro-rated annual interest",
		"fr": "* Solde approximatif, y compris les intérêts annuels calculés au prorata"
	},
	"tool.systematicWithdrawlsFootnote" : {
		"en": "* Approximate values, based on pro-rated annual interest",
		"fr": "* Valeurs approximatives basées sur les intérêts annuels calculés au prorata"
	},		
	"tool.chartContribution" : {
		"en": "Contribution",
		"fr": "Contribution"
	},
	"tool.chartValue" : {
		"en": "Value",
		"fr": "Valeur"
	},	
	"tool.chartTotalContribution" : {
		"en": "Total Contributions",
		"fr": "Cotisations totales"
	},	
	"tool.chartFutureValue" : {
		"en": "Future value",
		"fr": "Valeur future"
	},
	"tool.chartWithdrawal" : {
		"en": "Withdrawal",
		"fr": "Retrait"
	},	
	"tool.chartBalance" : {
		"en": "Balance",
		"fr": "Solde"
	},
	
	// Repeater
	"repeater.totalRows" : {
		"en": "total rows",
		"fr": "Nombre total de lignes"
	},


	// Dropdowns
	// Gender
	"dropdown.gender.male" : {
		"en": "Male",
		"fr": "Mâle"
	},
	"dropdown.gender.female" : {
		"en": "Female",
		"fr": "Femelle"
	},

	// True/False
	"dropdown.trueFalse.true" : {
		"en": "True",
		"fr": "Vrais"
	},
	"dropdown.trueFalse.false" : {
		"en": "False",
		"fr": "Faux"
	},

	// Province
	"dropdown.province.ontario" : {
		"en": "Ontario",
		"fr": "Ontario"
	},
	"dropdown.province.quebec" : {
		"en": "Quebec",
		"fr": "Québec"
	},
	"dropdown.province.alberta" : {
		"en": "Alberta",
		"fr": "Alberta"
	},			
	"dropdown.province.bc" : {
		"en": "British Columbia",
		"fr": "Colombie-Britannique"
	},	
	"dropdown.province.manitoba" : {
		"en": "Manitoba",
		"fr": "Manitoba"
	},	
	"dropdown.province.newbrunswick" : {
		"en": "New Brunswick",
		"fr": "Nouveau-Brunswick"
	},	
	"dropdown.province.newfoundland" : {
		"en": "Newfoundland & Labrador",
		"fr": "Terre-Neuve-et-Labrador"
	},	
	"dropdown.province.northwestterritories" : {
		"en": "Northwest Territiories",
		"fr": "Territoires du Nord-Ouest"
	},	
	"dropdown.province.novascotia" : {
		"en": "Nova Scotia",
		"fr": "Nouvelle-Écosse"
	},	
	"dropdown.province.nunavut" : {
		"en": "Nunavut",
		"fr": "Nunavut"
	},	
	"dropdown.province.pei" : {
		"en": "Prince Edward Island",
		"fr": "Île-du-Prince-Édouard"
	},	
	"dropdown.province.saskatchewan" : {
		"en": "Saskatchewan",
		"fr": "Saskatchewan"
	},
	"dropdown.province.yukon" : {
		"en": "Yukon",
		"fr": "Yukon"
	},		

	// Marital Status
	"dropdown.maritalStatus.married" : {
		"en": "Married",
		"fr": "Marié(e)"
	},	
	"dropdown.maritalStatus.single" : {
		"en": "Single",
		"fr": "Célibataire"
	},
	"dropdown.maritalStatus.separated" : {
		"en": "Separated",
		"fr": "Séparé(e)"
	},
	"dropdown.maritalStatus.divorced" : {
		"en": "Divorced",
		"fr": "Divorcé(e)"
	},
	"dropdown.maritalStatus.widowed" : {
		"en": "Widowed",
		"fr": "Veuf(ve)"
	},
	"dropdown.maritalStatus.other" : {
		"en": "Other",
		"fr": "Autre"
	},	
				
	// Months
	"dropdown.months.january" : {
		"en": "January",
		"fr": "Janvier"
	},	
	"dropdown.months.february" : {
		"en": "February",
		"fr": "Février"
	},	
	"dropdown.months.march" : {
		"en": "March",
		"fr": "Mars"
	},	
	"dropdown.months.april" : {
		"en": "April",
		"fr": "Avril"
	},	
	"dropdown.months.may" : {
		"en": "May",
		"fr": "Mai"
	},	
	"dropdown.months.june" : {
		"en": "June",
		"fr": "Juin"
	},	
	"dropdown.months.july" : {
		"en": "July",
		"fr": "Juillet"
	},	
	"dropdown.months.august" : {
		"en": "August",
		"fr": "Août"
	},	
	"dropdown.months.september" : {
		"en": "September",
		"fr": "Septembre"
	},	
	"dropdown.months.october" : {
		"en": "October",
		"fr": "Octobre"
	},	
	"dropdown.months.november" : {
		"en": "November",
		"fr": "Novembre"
	},	
		"dropdown.months.december" : {
		"en": "December",
		"fr": "Décembre"
	},

	// Contribution Frequency
	"dropdown.contributionFrequency.annual" : {
		"en": "Annual",
		"fr": "Annuelle"
	},	
	"dropdown.contributionFrequency.semimonthly" : {
		"en": "Semi-Monthly",
		"fr": "Semi-mensuelle"
	},		
	"dropdown.contributionFrequency.biweekly" : {
		"en": "Bi-Weekly",
		"fr": "Bimensuelle"
	},	
	"dropdown.contributionFrequency.weekly" : {
		"en": "Weekly",
		"fr": "Chaque semaine"
	},		
	"dropdown.contributionFrequency.monthly" : {
		"en": "Monthly",
		"fr": "Mensuelle"
	},


	// withdrawalOrder
	"dropdown.withdrawalOrder.r_l_s_t" : {
		"en": "RRSP / Locked-in / Savings / TFSA",
		"fr": "REER / CRI / Épargne / CELI"
	},			
	"dropdown.withdrawalOrder.r_l_t_s" : {
		"en": "RRSP / Locked-in / TFSA / Savings",
		"fr": "REER / CRI / CELI / Épargne"
	},			
	"dropdown.withdrawalOrder.r_s_l_t" : {
		"en": "RRSP / Savings / Locked-in / TFSA",
		"fr": "REER / Épargne / CRI / CELI"
	},			
	"dropdown.withdrawalOrder.r_s_t_l" : {
		"en": "RRSP / Savings / TFSA / Locked-in",
		"fr": "REER / Épargne / CELI / CRI"
	},	
	"dropdown.withdrawalOrder.r_t_s_l" : {
		"en": "RRSP / TFSA / Savings / Locked-in",
		"fr": "REER / CELI / Épargne / CRI"
	},			
	"dropdown.withdrawalOrder.r_t_l_s" : {
		"en": "RRSP / TFSA / Locked-in / Savings",
		"fr": "REER / CELI / CRI / Épargne"
	},	
	"dropdown.withdrawalOrder.l_r_s_t" : {
		"en": "Locked-in / RRSP / Savings / TFSA",
		"fr": "CRI / REER / Épargne / CELI"
	},			
	"dropdown.withdrawalOrder.l_r_t_s" : {
		"en": "Locked-in / RRSP / TFSA / Savings",
		"fr": "CRI / REER / CELI / Épargne"
	},			
	"dropdown.withdrawalOrder.l_s_r_t" : {
		"en": "Locked-in / Savings / RRSP / TFSA",
		"fr": "CRI / Épargne / REER / CELI"
	},			
	"dropdown.withdrawalOrder.l_s_t_r" : {
		"en": "Locked-in / Savings / TFSA / RRSP",
		"fr": "Placements immobilisés / Épargne / CELI / REER"
	},	
	"dropdown.withdrawalOrder.l_t_r_s" : {
		"en": "Locked-in / TFSA / RRSP / Savings",
		"fr": "Placements immobilisés / CELI / REER / Épargne"
	},			
	"dropdown.withdrawalOrder.l_t_s_r" : {
		"en": "Locked-in / TFSA / Savings / RRSP",
		"fr": "Placements immobilisés / CELI / Épargne / REER"
	},
	"dropdown.withdrawalOrder.s_l_r_t" : {
		"en": "Savings / Locked-in / RRSP / TFSA",
		"fr": "Épargne / CRIe / REER / CELI"
	},			
	"dropdown.withdrawalOrder.s_l_t_r" : {
		"en": "Savings / Locked-in / TFSA / RRSP",
		"fr": "Épargne / Placements immobilisés / CELI / REER"
	},			
	"dropdown.withdrawalOrder.s_r_l_t" : {
		"en": "Savings / RRSP / Locked-in / TFSA",
		"fr": "Épargne / REER / CRI / CELI"
	},			
	"dropdown.withdrawalOrder.s_r_t_l" : {
		"en": "Savings / RRSP / TFSA / Locked-in",
		"fr": "Épargne / REER / CELI / CRI"
	},	
	"dropdown.withdrawalOrder.s_t_r_l" : {
		"en": "Savings / TFSA / RRSP / Locked-in",
		"fr": "Épargne / CELI / REER / Placements immobilisés"
	},			
	"dropdown.withdrawalOrder.s_t_l_r" : {
		"en": "Savings / TFSA / Locked-in / RRSP",
		"fr": "Épargne / CELI / Placements immobilisés / REER"
	},	
	"dropdown.withdrawalOrder.t_s_r_l" : {
		"en": "TFSA / Savings / RRSP / Locked-in",
		"fr": "CELI / Épargne / REER / Placements immobilisés"
	},			
	"dropdown.withdrawalOrder.t_s_l_r" : {
		"en": "TFSA / Savings / Locked-in / RRSP",
		"fr": "CELI / Épargne / Placements immobilisés / REER"
	},			
	"dropdown.withdrawalOrder.t_r_l_s" : {
		"en": "TFSA / RRSP / Locked-in / Savings",
		"fr": "CELI / REER / Placements immobilisés / Épargne"
	},			
	"dropdown.withdrawalOrder.t_r_s_l" : {
		"en": "TFSA / RRSP / Savings / Locked-in",
		"fr": "CELI / REER / Épargne / Placements immobilisés"
	},	
	"dropdown.withdrawalOrder.t_l_s_r" : {
		"en": "TFSA / Locked-in / Savings / RRSP",
		"fr": "CELI / Placements immobilisés / Épargne / REER"
	},			
	"dropdown.withdrawalOrder.t_l_r_s" : {
		"en": "TFSA / Locked-in / RRSP / Savings",
		"fr": "CELI / Placements immobilisés / REER / épargne"
	},


	// Repeater Fields
	"repeater.institution" : {
		"en": "Institution",
		"fr": "Établissement"		
	},
	"repeater.accountName" : {
		"en": "Account Name",
		"fr": "Nom du compte"		
	},	
	"repeater.balance" : {
		"en": "Balance",
		"fr": "Solde"		
	},	
	"repeater.contribution" : {
		"en": "Contribution",
		"fr": "Cotisation"		
	},	
	"repeater.contributionFrequency" : {
		"en": "Contribution Frequency",
		"fr": "Fréquence des cotisations"		
	},	
	"repeater.rate" : {
		"en": "Rate",
		"fr": "Taux"		
	},	
	"repeater.startingAge" : {
		"en": "Starting Age",
		"fr": "Âge de début"		
	},
	"repeater.monthlyPayment" : {
		"en": "Monthly Payment",
		"fr": "Paiement mensuel"		
	},
	"repeater.amortization" : {
		"en": "Amortization",
		"fr": "Amortissement"		
	},
	"repeater.paymentAmount" : {
		"en": "Payment Amount",
		"fr": "Montant du paiement"		
	},
	"repeater.numberPayments" : {
		"en": "Number of Payments",
		"fr": "Nombre de paiements"		
	},
	"repeater.propertyName" : {
		"en": "Property Name",
		"fr": "Nom de la propriété"		
	},
	"repeater.value" : {
		"en": "Value",
		"fr": "Valeur"		
	},
	"repeater.growthRate" : {
		"en": "Growth Rate",
		"fr": "Taux de croissance"		
	},						
	"repeater.month" : {
		"en": "Month",
		"fr": "Mois"		
	},
	"repeater.year" : {
		"en": "Year",
		"fr": "Année"		
	},
	"repeater.eventName" : {
		"en": "Event Name",
		"fr": "Nom de l'événement"		
	},						
	"repeater.shock" : {
		"en": "TSX Shock",
		"fr": "TSX perturbé par un choc négatif"		
	},
	"repeater.next12" : {
		"en": "Next 12 Months TSX",
		"fr": "TSX au cours de 12 prochains mois"		
	},
	"repeater.age" : {
		"en": "Age",
		"fr": "Âge"		
	},						
	"repeater.minWithdrawal" : {
		"en": "Minimum Withdrawal %",
		"fr": "% de retrait minimum"		
	},
	"repeater.maxWithdrawal" : {
		"en": "Maximum Withdrawal %",
		"fr": "% de retrait maximum"		
	},
	"repeater.disclaimerName" : {
		"en": "Disclaimer Name",
		"fr": "Nom de l'avis de non-responsabilité"		
	},
	"repeater.disclaimerText" : {
		"en": "Disclaimer Text",
		"fr": "Texte d'avis de non-responsabilité"		
	},
	"repeater.disclaimerTextFr" : {
		"en": "Disclaimer Text - French",
		"fr": "Texte d’avis de non-responsabilité – Français"		
	},

	// Net Worth
	"netWorth.title" : {
		"en": "Net Worth",
		"fr": "Valeur nette"
	},
	"netWorth.netWorth" : {
		"en": "Net Worth",
		"fr": "Valeur nette"
	},
	"netWorth.totalNetWorth" : {
		"en": "Total Net Worth",
		"fr": "Valeur nette totale"
	},
	"netWorth.assetsTitle" : {
		"en": "Assets:",
		"fr": "Actifs :"
	},
	"netWorth.assets" : {
		"en": "Assets",
		"fr": "Actifs"
	},
	"netWorth.assetsTotal" : {
		"en": "Total Assets",
		"fr": "Total des actifs"
	},
	"netWorth.assetsLiabilities" : {
		"en": "Total Liabilities",
		"fr": "Total des passifs"
	},	
	"netWorth.liquidAssets" : {
		"en": "Liquid Assets",
		"fr": "Actifs liquides"
	},
	"netWorth.chequingAccounts" : {
		"en": "Chequing Accounts:",
		"fr": "Comptes de chèques :"
	},
	"netWorth.savingsAccounts" : {
		"en": "Savings Accounts",
		"fr": "Comptes d'épargne"
	},
	"netWorth.semiliquidAssets" : {
		"en": "Semi-Liquid Assets",
		"fr": "Actifs semi-liquides"
	},
	"netWorth.tfsasTotal" : {
		"en": "TFSAs Total",
		"fr": "Montant total détenu dans les CELI"
	},
	"netWorth.stocksTotal" : {
		"en": "Stocks Total",
		"fr": "Total des actifs"
	},
	"netWorth.mutualFundsTotal" : {
		"en": "Mutual Funds Total",
		"fr": "Total des fonds communs de placement"
	},
	"netWorth.otherSecuritiesTotal" : {
		"en": "Other Securities Total",
		"fr": "Total des autres titres de placement"
	},
	"netWorth.retirementSavings" : {
		"en": "Retirement Savings",
		"fr": "Épargne-retraite"
	},			
	"netWorth.other" : {
		"en": "Other",
		"fr": "Autre"
	},			
	"netWorth.dpspEsopGrsp" : {
		"en": "DPSP/ESOP/GRSP",
		"fr": "RPDB/RADE/RERC"
	},			
	"netWorth.rrifs" : {
		"en": "RRIFs",
		"fr": "FERR"
	},			
	"netWorth.employerPensionPlan" : {
		"en": "Employer Pension Plan",
		"fr": "Régime de retraite de l'employeur"
	},			
	"netWorth.lockedinRrsp" : {
		"en": "Locked-in RRSP",
		"fr": "CRI"
	},			
	"netWorth.realEstate" : {
		"en": "Real Estate",
		"fr": "Immobilier"
	},			
	"netWorth.homeValue" : {
		"en": "Home Value",
		"fr": "Valeur de la maison"
	},			
	"netWorth.otherRealEstateValue" : {
		"en": "Other Real Estate Value",
		"fr": "Autre valeur immobilière"
	},			
	"netWorth.personalProperty" : {
		"en": "Personal Property",
		"fr": "Biens personnels"
	},			
	"netWorth.taxDeferredAssets" : {
		"en": "Tax Deferred Assets",
		"fr": "Actifs d'impôts différés"
	},			
	"netWorth.businessInterests" : {
		"en": "Business Interests",
		"fr": "Intérêts commerciaux"
	},			
	"netWorth.liabilitiesTitle" : {
		"en": "Liabilities:",
		"fr": "Passifs :"
	},							
	"netWorth.liabilities" : {
		"en": "Liabilities",
		"fr": "Passifs"
	},
	"netWorth.shortTermDebt" : {
		"en": "Short Term Debt",
		"fr": "Dette à court terme"
	},		
	"netWorth.creditCards" : {
		"en": "Credit Cards",
		"fr": "Cartes de crédit"
	},		
	"netWorth.carLoans" : {
		"en": "Car Loans",
		"fr": "Prêts-autos"
	},		
	"netWorth.lineOfCredit" : {
		"en": "Line of Credit",
		"fr": "Marge de crédit"
	},		
	"netWorth.otherLiabilities" : {
		"en": "Other Liabilities",
		"fr": "Autres passifs"
	},		
	"netWorth.longTermDebt" : {
		"en": "Long Term Debt",
		"fr": "Dette à long terme"
	},		
	"netWorth.mortgageOnHome" : {
		"en": "Mortgage on Home",
		"fr": "Hypothèque sur la maison"
	},		
	"netWorth.otherMortgages" : {
		"en": "Other Mortgages",
		"fr": "Autres prêts hypothécaires"
	},		
	"netWorth.investmentLoans" : {
		"en": "Investment Loans",
		"fr": "Prêts à l'investissement"
	},
	"netWorth.chequing" : {
		"en": "Chequing",
		"fr": "Prêts à l'investissement"
	},
	"netWorth.chequingAccounts" : {
		"en": "Chequing Accounts",
		"fr": "Prêts à l'investissement"
	},	
	"netWorth.registered" : {
		"en": "Registered",
		"fr": "Enregistrés"
	},

	"netWorth.savings" : {
		"en": "Savings",
		"fr": "Économies"
	},
	"netWorth.savingsAccounts" : {
		"en": "Savings Accounts",
		"fr": "Économies"
	},
	"netWorth.tfsa" : {
		"en": "TFSAs",
		"fr": "CELI"
	},
	"netWorth.stocks" : {
		"en": "Stocks",
		"fr": "Actions"
	},
	"netWorth.mutualFunds" : {
		"en": "Mutual Funds",
		"fr": "Fonds communs de placement"
	},
	"netWorth.registeredMutualFunds" : {
		"en": "Registered Mutual Funds",
		"fr": "Fonds communs de placement enregistrés"
	},
	"netWorth.otherRegistered" : {
		"en": "Other Registered",
		"fr": "Autres placements enregistrés"
	},
	"netWorth.rrifs" : {
		"en": "RRIFs",
		"fr": "Pension de l'employeur"
	},
	"netWorth.employerPension" : {
		"en": "Employer Pension",
		"fr": "Pension de l'employeur"
	},
	"netWorth.familyHome" : {
		"en": "Family Home",
		"fr": "Maison familiale"
	},
	"netWorth.otherRealEstate" : {
		"en": "Other Real Estate",
		"fr": "Autres biens immobiliers"
	},
	"netWorth.otherAssets" : {
		"en": "Other Assets",
		"fr": "Autres actifs"
	},
	"netWorth.spouseReport" : {
		"en": "Include spouse assets in report",
		"fr": false,
	},


	// Retirement Planner
	"retirementPlanner.title" : {
		"en": "Retirement Planner",
		"fr": "Planificateur de retraite"
	},
	"retirementPlanner.outlookTitle" : {
		"en": "Retirement Outlook",
		"fr": "Perspectives de retraite"
	},	
	"retirementPlanner.yearsInRetirement" : {
		"en": "Years in Retirement",
		"fr": "Années de retraite"
	},	
	"retirementPlanner.investmentAssetsAtRetirement" : {
		"en": "Investment Assets at Retirement",
		"fr": "Actifs de placement à la retraite"
	},	
	"retirementPlanner.targetValueOfEstate" : {
		"en": "Target Value of Estate",
		"fr": "Valeur cible de la succession"
	},	
	"retirementPlanner.shortfallExcess" : {
		"en": "Shortfall/Excess",
		"fr": "Insuffisance/excédent"
	},	
	"retirementPlanner.requiredOneTimeInvestmentAt" : {
		"en": "Required One Time Investment at",
		"fr": "Investissement ponctuel requis au"
	},
	"retirementPlanner.distributeWealth" : {
		"en": "Distribute Wealth:",
		"fr": "Distribuer la richesse :"
	},	
	"retirementPlanner.byIncome" : {
		"en": "By Income",
		"fr": "Par revenu"
	},	
	"retirementPlanner.retirementIncomeRequired" : {
		"en": "Retirement Income Required",
		"fr": "Revenu de retraite requis"
	},		
	"retirementPlanner.presentAge" : {
		"en": "Present Age",
		"fr": "Âge actuel"
	},								
	"retirementPlanner.presentYearlyIncome" : {
		"en": "Present Yearly Income",
		"fr": "Revenu annuel actuel"
	},								
	"retirementPlanner.ageToRetire" : {
		"en": "Age to Retire",
		"fr": "Âge de la retraite"
	},								
	"retirementPlanner.targetIncomeAtRetirement" : {
		"en": "Projected Income at Retirement %",
		"fr": "% du revenu cible prévu"
	},								
	"retirementPlanner.incomeAtRetirement" : {
		"en": "Projected Income at age %s",
		"fr": "Revenu prevu à l’âge de %s"
	},
	"retirementPlanner.ageOfPassiveRetirement" : {
		"en": "Age of Passive Retirement",
		"fr": "Âge de la retraite passive"
	},
	"retirementPlanner.incomeRequiredPassiveRetirement" : {
		"en": "Income Required in Passive Retirement",
		"fr": "Revenu requis à la retraite passive"
	},
	"retirementPlanner.projectedRateOfInflation" : {
		"en": "Projected Rate of Inflation",
		"fr": "Taux d'inflation prévu"
	},
	"retirementPlanner.projectedRateOfReturn" : {
		"en": "Projected Rate of Return",
		"fr": "Taux de rendement prévu"
	},
	"retirementPlanner.estimatedLifeExpectancy" : {
		"en": "Estimated Life Expectancy",
		"fr": "Espérance de vie estimée"
	},
	// "retirementPlanner.presentAge" : {
	// 	"en": "Present Age",
	// 	"fr": "false"
	// },	
	// "retirementPlanner.presentYearlyIncome" : {
	// 	"en": "Present Yearly Income",
	// 	"fr": false
	// },	
	// "retirementPlanner.ageToRetire" : {
	// 	"en": "Age to Retire",
	// 	"fr": false
	// },	
	// "retirementPlanner.targetIncomeAtRetirement" : {
	// 	"en": "Target Income at Retirement %",
	// 	"fr": false
	// },	
	// "retirementPlanner.incomeAtRetirement" : {
	// 	"en": "Income at Retirement",
	// 	"fr": false
	// },	
	"retirementPlanner.ageOfPassiveRetirement" : {
		"en": "Age of Passive Retirement",
		"fr": "Revenu requis à la retraite passive"
	},	
	"retirementPlanner.incomeRequiredInPassiveRetirement" : {
		"en": "Income Required in Passive Retirement",
		"fr": "Prestations gouvernementales"
	},	
	// "retirementPlanner.projectedRateOfInflation" : {
	// 	"en": "Projected Rate of Inflation",
	// 	"fr": "false"
	// },	
	// "retirementPlanner.projectedRateOfReturn" : {
	// 	"en": "Projected Rate of Return",
	// 	"fr": false
	// },	
	// "retirementPlanner.estimatedLifeExpectancy" : {
	// 	"en": "Estimated Life Expectancy",
	// 	"fr": false
	// },	
	"retirementPlanner.governmentBenefits" : {
		"en": "Government Benefits",
		"fr": "Prestations gouvernementales"
	},	
	"retirementPlanner.currentMaximumCppPayout" : {
		"en": "Current maximum CPP payout",
		"fr": "Montant maximal actuel de la prestation du RPC"
	},	
	"retirementPlanner.projectedEligibleCppAtAgeOf" : {
		"en": "Projected Eligible CPP at age of %s",
		"fr": "Admissibilité prévue aux prestations du RPC à l’âge de %s"
	},	
	"retirementPlanner.indexCppAt" : {
		"en": "Index CPP at",
		"fr": "Indexer les prestations du RPC à"
	},	
	"retirementPlanner.currentMaximumOasPayout" : {
		"en": "Current maximum OAS payout",
		"fr": "Prestations maximales actuelles du RPC"
	},	
	"retirementPlanner.projectedOasAtTheAgeOf" : {
		"en": "Projected OAS at the age of %s",
		"fr": "Prestations prévues de la SV à l'âge de %s"
	},	
	"retirementPlanner.indexOasAt" : {
		"en": "Index OAS at",
		"fr": "Indexer les prestations de SV à"
	},	
	"retirementPlanner.summaryCurrentValue" : {
		"en": "Current value",
		"fr": "Valeur actuelle"
	},	
	"retirementPlanner.summaryTotalValueAtRetirement" : {
		"en": "Total value at retirement",
		"fr": "Valeur totale à la retraite"
	},	
	"retirementPlanner.summaryTotalContributions" : {
		"en": "Total contributions",
		"fr": "Cotisations totales"
	},	
	"retirementPlanner.summaryRateOfReturn" : {
		"en": "Rate of Return",
		"fr": "Taux de rendement"
	},	


	"retirementPlanner.savingsInvestmentTitle" : {
		"en": "Regular Savings/Investments",
		"fr": "Épargne et placements réguliers"
	},
	"retirementPlanner.tfsaTitle" : {
		"en": "Tax Free Savings Account (TFSA)",
		"fr": "Compte d'épargne libre d'impôt (CELI)"
	},
	"retirementPlanner.registeredInvestmentsTitle" : {
		"en": "Registered Investments",
		"fr": "Placements enregistrés"
	},
	"retirementPlanner.dpspTitle" : {
		"en": "DPSP",
		"fr": "RPDB"
	},
	"retirementPlanner.lockedinInvetmentsTitle" : {
		"en": "Locked-in Investments",
		"fr": "Placements immobilisés"
	},




	"retirementPlanner.pensionTitle" : {
		"en": "Pension",
		"fr": "Pension"
	},	
	"retirementPlanner.startReceivingPensionAtAge" : {
		"en": "Start receiving pension at age",
		"fr": "Commencer à recevoir une pension à l'âge de"
	},	
	"retirementPlanner.integrateWithCpp" : {
		"en": "Integrate with CPP",
		"fr": "Intégrer au RPC"
	},	
	"retirementPlanner.indexPensionAt" : {
		"en": "Index pension at",
		"fr": "Pension indexée à"
	},	
	"retirementPlanner.projectedInitialBenefit" : {
		"en": "Projected initial benefit",
		"fr": "Prestation initiale prévue"
	},	
	"retirementPlanner.pensionBridgeAmount" : {
		"en": "Pension has a bridge amount",
		"fr": "La pension comporte un montant de raccordement"
	},	
	"retirementPlanner.brdigeBenefitAmount" : {
		"en": "Bridge benefit amount",
		"fr": "Montant de la prestation de raccordement"
	},
	"retirementPlanner.bridgeBenefitStarts" : {
		"en": "Bridge benefit starts at age",
		"fr": "La prestation de raccordement commence à l'âge de"
	},
	"retirementPlanner.bridgeBenefitEnds" : {
		"en": "Bridge benefit ends at age",
		"fr": "La prestation de raccordement prend fin à l'âge de"
	},
	"retirementPlanner.age" : {
		"en": "Age",
		"fr": "Âge"
	},
	"retirementPlanner.wealthAccumulation" : {
		"en": "Wealth Accumulation",
		"fr": "Accumulation de richesse"
	},
	"retirementPlanner.deaccumulation" : {
		"en": "De-Accumulation",
		"fr": "Désaccumulation"
	},
	"retirementPlanner.postRetirementCashFlows" : {
		"en": "Post-Retirement Cash Flows",
		"fr": "Flux de trésorerie après la retraite"
	},
	"retirementPlanner.details" : {
		"en": "Details",
		"fr": "Détails"
	},
	"retirementPlanner.remainingWealth" : {
		"en": "Remaining Wealth",
		"fr": "Richesse restante"
	},	
	"retirementPlanner.cashFlows" : {
		"en": "Cash Flows",
		"fr": "Flux de trésorerie"
	},		
	"retirementPlanner.year" : {
		"en": "Year",
		"fr": "Année"
	},	
	"retirementPlanner.income" : {
		"en": "Income",
		"fr": "Revenu"
	},	
	"retirementPlanner.savings" : {
		"en": "Savings",
		"fr": "Économies"
	},	
	"retirementPlanner.lockedin" : {
		"en": "Locked In",
		"fr": "CRI"
	},
	"retirementPlanner.registered" : {
		"en": "Registered",
		"fr": "Régime enregistré d’épargne-retraite"
	},
	"retirementPlanner.tfsa" : {
		"en": "TFSA",
		"fr": "CELI"
	},
	"retirementPlanner.cpp" : {
		"en": "CPP",
		"fr": "RPC"
	},
	"retirementPlanner.oas" : {
		"en": "OAS",
		"fr": "SV"
	},
	"retirementPlanner.pension" : {
		"en": "Pension",
		"fr": "Pension"
	},		
	"retirementPlanner.other" : {
		"en": "Other Income",
		"fr": "Autres revenus"
	},


	// Financial GPS
	"financialGps.title" : {
		"en": "Financial GPS",
		"fr": "GPS financier"
	},
	"financialGps.riskBudgetFor" : {
		"en": "Risk Budget for",
		"fr": "Budget de risque pour"
	},
	"financialGps.riskBudgetText" : {
		"en": "A risk budget is a tool offered by Rose & Associates to help clients manage risk and be more informed about their plans and goals. To create your personalized risk budget, some information is required.",
		"fr": "Un budget de risque est un outil offert par Rose & Associates pour aider les clients à gérer les risques et à mieux connaître leurs plans et objectifs. Pour créer votre budget de risque personnalisé, vous devez fournir certaines informations."
	},
	"financialGps.clientName" : {
		"en": "Client Name",
		"fr": "Nom du client"
	},
	"financialGps.currentAge" : {
		"en": "Current Age",
		"fr": "Âge actuel"
	},
	"financialGps.planStartingYear" : {
		"en": "Plan Starting Year",
		"fr": "Planifier l'année de début"
	},
	"financialGps.currentYear" : {
		"en": "Current Year",
		"fr": "Année en cours"
	},
	"financialGps.ageAtRetirement" : {
		"en": "Age at Retirement",
		"fr": "Âge à la retraite"
	},
	"financialGps.yearOfRetirement" : {
		"en": "Year of Retirement",
		"fr": "Année de la retraite"
	},
	"financialGps.currentValue" : {
		"en": "Current Value",
		"fr": "Valeur actuelle"
	},
	"financialGps.startingAssets" : {
		"en": "Starting Assets",
		"fr": "Actifs de départ"
	},
	"financialGps.assetGoalAtRetirement" : {
		"en": "Asset Goal at Retirement",
		"fr": "Objectif d’actifs à la retraite"
	},
	"financialGps.annualContributions" : {
		"en": "Annual Contributions",
		"fr": "Cotisations annuelles"
	},
	"financialGps.indexation" : {
		"en": "Indexation",
		"fr": "Indexation"
	},
	"financialGps.assumptions" : {
		"en": "Using these assumptions, we can calculate the annual rate of return your portfolio will need to earn to achieve your retirement and estate goals.",
		"fr": "À l'aide de ces hypothèses, nous pouvons calculer le taux de rendement annuel que votre portefeuille devra générer pour atteindre vos objectifs de retraite et de succession."
	},					
	"financialGps.rateOfReturnRequired" : {
		"en": "Rate of Return Required",
		"fr": "Taux de rendement requis"
	},
	"financialGps.rateOfReturnRequiredRetirement" : {
		"en": "Rate of Return Required in Retirement",
		"fr": "Taux de rendement requis à la retraite"
	},	
	"financialGps.financialGpsProjections" : {
		"en": "Financial GPS Projections",
		"fr": "Projections de GPS financier"
	},
	"financialGps.financialGpsProjectionsParagraph1" : {
		"en": "We believe that peace of mind is the most important thing a financial advisor can offer to a retiree. That peace of mind comes from knowing that the goals you set are reasonable and attainable, and that your portfolio is resilient to negative shocks.",
		"fr": "Nous croyons que la tranquillité d'esprit est la chose la plus importante qu'un conseiller financier puisse offrir à un retraité. Cette tranquillité d'esprit vient du fait de savoir que les objectifs que vous vous êtes fixés sont raisonnables et réalisables, et que votre portefeuille résiste aux chocs négatifs."
	},
	"financialGps.financialGpsProjectionsParagraph2" : {
		"en": "Furthermore, below is a graph which illustrates the asset values required to reach your estate goal(in blue) while enjoying your target lifestyle. Also illustrated in yellow are the actual portfolio values that your investments have achieved.",
		"fr": "De plus, le graphique ci-dessous illustre les valeurs d’actif requises pour atteindre votre objectif de patrimoine (en bleu) tout en profitant du style de vie que vous visez. Les valeurs réelles de votre portefeuille de placements sont indiquées en jaune."
	},
	"financialGps.savings" : {
		"en": "Savings (Accumulation)",
		"fr": "Épargne (accumulation)"
	},
	"financialGps.retirement" : {
		"en": "Retirement (De-Accumulation)",
		"fr": "Retraite (désaccumulation)"
	},
	"financialGps.portfolioResilience" : {
		"en": "Portfolio Resilience",
		"fr": "Résilience du portefeuille"
	},
	"financialGps.portfolioResilienceParagraph1" : {
		"en": "Mitigating risk is a key element to sound financial management. The chart below illustrates the rate of return that your portfolio would need to earn to fund your retirement and reach your estate goal if it were to experience a range of negative shocks this year.",
		"fr": "L'atténuation des risques est un élément clé d'une saine gestion financière. Le graphique ci-dessous illustre le taux de rendement que votre portefeuille devrait générer pour financer votre retraite et atteindre votre objectif de patrimoine s'il devait subir une série de chocs négatifs cette année."
	},
	"financialGps.portfolioResilienceParagraph2" : {
		"en": "Finally, we would like to define what we deem to be a shock. Rose & Associates defines a shock as an abnormal drop in asset value, without a corresponding abnormal rise in asset value. True shocks are rarer than most believe; a major market drop is frequently accompanied by a major market rise or recovery. Below is a table that charts the largest market drops to the Toronto Stock Exchange index in recent history, and the activity in the following 12 months.",
		"fr": "Enfin, il serait bon de définir ce que nous entendons par choc négatif.  Rose & Associates définit un choc négatif comme une baisse anormale de la valeur d'un actif, sans hausse anormale correspondante de la valeur de l'actif. Les vrais chocs sont plus rares qu'on ne le croit; une chute importante du marché s'accompagne souvent d'une hausse ou d'une reprise importante du marché. Le tableau ci-dessous présente les plus fortes baisses de l'indice de la Bourse de Toronto au cours des 12 derniers mois et l'activité au cours des 12 mois suivants."
	},
	"financialGps.shockEvent" : {
		"en": "Shock Event",
		"fr": "Événements perturbés par des chocs négatifs"
	},
	"financialGps.tsxShock" : {
		"en": "TSX Shock",
		"fr": "TSX perturbé par un choc négatif"
	},
	"financialGps.next12" : {
		"en": "Next 12 Months TSX Performance",
		"fr": "Rendement de la TSX au cours des 12 prochains mois"
	},
	"financialGps.actualValue" : {
		"en": "Actual Value",
		"fr": "Valeur réelle"
	},
	"financialGps.projectedValue" : {
		"en": "Original Plan",
		"fr": "Valeur projetée"
	},				
	"financialGps.adjustedValue" : {
		"en": "Adjusted Plan",
		"fr": "Valeur projetée"
	},
	"financialGps.useAdjusted" : {
		"en": "Apply plan adjustments",
		"fr": "Valeur projetée"
	},
	"financialGps.adjustedGoal" : {
		"en": "Adjusted Plan Goal",
		"fr": "Valeur projetée"		
	},
	"financialGps.adjustmentTitle" : {
		"en": "Plan Adjustments",
		"fr": "Valeur projetée"		
	},
	"financialGps.adjustmentText" : {
		"en": "The adjusted plan can be used to account for periods on which the anticipated contributions or withdrawals vary from the values included in the original plan. These values can be defined within the User panel through the Adjusted Contributions and Adjusted Withdrawals.",
		"fr": "Valeur projetée"		
	},	
	"financialGps.adjustmentText2" : {
		"en": "A new series line will be charted using the same growth rate as the original plan, but substituting the anticipated contributions or withdrawals with the adjusted values defined for a given period.",
		"fr": "Valeur projetée"		
	},

	// Print
	"print.title" : {
		"en": "Print / PDF Output",
		"fr": "Impression / Sortie PDF"
	},	
	"print.button" : {
		"en": "Generate PDF",
		"fr": "Générer PDF"
	},
	"print.printSections" : {
		"en": "Print Sections",
		"fr": "Imprimer les sections"
	},
	"print.printCoverPage" : {
		"en": "Print Cover Page",
		"fr": "Imprimer la page couverture"
	},
	"print.printDisclaimer" : {
		"en": "Print Disclaimer",
		"fr": "Imprimer l'avis de non-responsabilité"
	},
	"print.printClientProfile" : {
		"en": "Print Client Profile",
		"fr": "Imprimer le profil du client"
	},
	"print.printNetWorthReport" : {
		"en": "Print Net Worth Report",
		"fr": "Imprimer le rapport sur la valeur nette patrimoniale"
	},
	"print.printRetirementPlannerReport" : {
		"en": "Print Retirement Planner Report",
		"fr": "Imprimer le rapport du planificateur de retraite"
	},
	"print.printFinancialGpsReport" : {
		"en": "Print Financial GPS Report",
		"fr": "Imprimer le rapport de GPS financier"
	},
	"print.printGlobalDisclaimers" : {
		"en": "Print Global Disclaimers",
		"fr": "Imprimer les avis généraux de non-responsabilité"
	},
	"print.printTool" : {
		"en": "Print %s",
		"fr": "Imprimer %s"
	},
	"print.printSectionsDetails" : {
		"en": "Various components and modules can be toggled on and off within the PDF output. Use the following controls to set which elements should be included.",
		"fr": "Différents composants et modules peuvent être activés et désactivés dans la sortie PDF. Utilisez les commandes suivantes pour définir les éléments à inclure."
	},	
	"print.printSubsections" : {
		"en": "Print Subsections",
		"fr": "Imprimer les sous-sections"
	},		
	"print.printSubsectionsDetails" : {
		"en": "For additional control, the following options allow you to select the specific elements that appear within the ",
		"fr": "Vous pouvez personnaliser davantage la sortie PDF en utilisant les options suivantes pour sélectionner des éléments spécifiques."
	},
	"print.reportLanguage" : {
		"en": "Report Language",
		"fr": "Langue du rapport"
	},
	"print.reportTitle" : {
		"en": "Report Title",
		"fr": "Titre du rapport"
	},
	"print.selectDisclaimer" : {
		"en": "Select Disclaimer",
		"fr": "Sélectionner l'avis de non-responsabilité"
	},
	"print.netWorthSections" : {
		"en": "Net Worth Sections",
		"fr": "Sections de la valeur nette patrimoniale"
	},
	"print.includeNetWorthSummary" : {
		"en": "Include Net Worth Summary",
		"fr": "Inclure le sommaire de la valeur nette patrimoniale"
	},
	"print.includeAssetLiabilityComparison" : {
		"en": "Include Asset/Liability Comparison",
		"fr": "Inclure la comparaison de l'actif et du passif"
	},
	"print.includeAssetsAccountsBreakdown" : {
		"en": "Breakdown asset accounts",
		"fr": "Breakdown asset accounts [FR]"
	},		
	"print.retirementPlannerSection" : {
		"en": "Retirement Planner Sections",
		"fr": "Sections de planification de la retraite"
	},
	"print.includeRetirementOutlook" : {
		"en": "Include Retirement Outlook",
		"fr": "Inclure les perspectives de retraite"
	},
	"print.includeRetirementIncomeRequired" : {
		"en": "Include Retirement Income Required",
		"fr": "Inclure le revenu de retraite requis"
	},
	"print.includePension" : {
		"en": "Include Pension",
		"fr": "Inclure la pension"
	},
	"print.includeGovernmentBenefits" : {
		"en": "Include Government Benefits",
		"fr": "Inclure les prestations gouvernementales"
	},
	"print.includeAssetValues" : {
		"en": "Include Asset Values",
		"fr": "Inclure les valeurs des actifs"
	},
	"print.includeWealthAccumulation" : {
		"en": "Include Wealth Accumulation",
		"fr": "Inclure l'accumulation de richesse"
	},
	"print.includeWealthDeaccumulation" : {
		"en": "Include De-Accumulation",
		"fr": "Inclure la désaccumulation"
	},
	"print.includePostRetirementCashFlows" : {
		"en": "Include Post-Retirement Cash Flows",
		"fr": "Inclure les flux de trésorerie après la retraite"
	},
	"print.includeChart" : {
		"en": "Include Chart",
		"fr": "Inclure le graphique"
	},
	"print.includeTable" : {
		"en": "Include Table",
		"fr": "Inclure la table"
	},								
	"print.financialGpsSection" : {
		"en": "Financial GPS Sections",
		"fr": "Sections de GPS financier"
	},
	"print.includeGpsDetails" : {
		"en": "Include GPS Details",
		"fr": "Inclure les détails de GPS financier"
	},
	"print.includeGpsProjections" : {
		"en": "Include GPS Projections",
		"fr": "Inclure les projections de GPS financier"
	},
	"print.includeGpsResilience" : {
		"en": "Include Portfolio Resilience",
		"fr": "Inclure la résilience du portefeuille"
	},	
	"print.disclaimerSection" : {
		"en": "Disclaimer Sections",
		"fr": "Clause de non-responsabilité"
	},
	"print.includeGlobalDisclaimer" : {
		"en": "Include General Disclaimer Text",
		"fr": "Inclure le texte de non-responsabilité générale"
	},					

	// General UI	
	"ui.edit" : {
		"en": "Edit",
		"fr": "Modifier"
	},
	"ui.delete" : {
		"en": "Delete",
		"fr": "Supprimer"
	},	
	"ui.save" : {
		"en": "Save",
		"fr": "Enregistrer"
	},
	"ui.cancel" : {
		"en": "Cancel",
		"fr": "Annuler"
	},
	"ui.add" : {
		"en": "Add",
		"fr": "Ajouter"
	},
	"ui.yes" : {
		"en": "Yes",
		"fr": "Oui"
	},
	"ui.no" : {
		"en": "No",
		"fr": "Non"
	},	
	"ui.editable" : {
		"en": "editable",
		"fr": "Modifiable"
	},
	"ui.requiredEntry" : {
		"en": "required entry",
		"fr": "Entrée obligatoire"
	},	
	"ui.reset" : {
		"en": "reset",
		"fr": "Réinitialiser"
	},


	// Assumptions 
	"disclaimers.title" : {
		"en": "Assumptions & Disclosures",
		"fr": "Hypothèses et divulgations"
	},
	"disclaimers.generalTitle" : {
		"en": "General Definitions",
		"fr": "Définitions générales"
	},
	"disclaimers.liraLifTitle" : {
		"en": "LIRA/LIF",
		"fr": "CRIF/FRV"
	},
	"disclaimers.liraLif" : {
		"en": "we assume all LIRA/LIF investments follow the PBSA Federal Legislation and thus the Federal withdrawal schedule applies.",
		"fr": "Nous supposons que tous les placements dans des CRIF/FRV sont conformes à la Loi fédérale sur les normes de prestation de pension et que, par conséquent, le calendrier de retrait fédéral s'applique."
	},
	"disclaimers.inflationLifTitle" : {
		"en": "Inflation",
		"fr": "Inflation"
	},
	"disclaimers.inflationLif" : {
		"en": "we apply 2.0% inflation, unless otherwise stated, on CPP, OAS, pensions and income needs.",
		"fr": "Nous appliquons un taux d'inflation de 2,0 %, sauf indication contraire, au RPC, à la SV, aux pensions et aux besoins de revenu."
	},	
	"disclaimers.clawbackTitle" : {
		"en": "OAS Clawback",
		"fr": "Récupération de la SV"
	},
	"disclaimers.clawback" : {
		"en": "the program does not account for possible OAS clawback. In 2024, once your taxable net income reaches $90,997, you will be subject to OAS clawback.",
		"fr": "Le programme ne tient pas compte d'une éventuelle récupération de la SV. En 2024, lorsque votre revenu net imposable atteindra 90 997 $, vous serez assujetti à la récupération de la SV."
	},			
	"disclaimers.strategyTitle" : {
		"en": "De-Accumulation Strategy",
		"fr": "Stratégie de désaccumulation"
	},
	"disclaimers.registeredFundsTitle" : {
		"en": "Registered Funds First",
		"fr": "Fonds enregistrés d'abord"
	},
	"disclaimers.registeredFunds" : {
		"en": "This strategy involves drawing income from registered funds first and maximizing the annual allowable from LIF accounts thus reducing the risk of leaving highly taxable registered accounts to an estate. The second priority is given to taxable non-registered accounts, withdrawing from Tax Free Savings Accounts (TFSA) last.",
		"fr": "Cette stratégie consiste à tirer d'abord un revenu des fonds enregistrés et à maximiser le montant annuel admissible des comptes FRV, réduisant ainsi le risque de laisser des comptes enregistrés hautement imposables à une succession. La deuxième priorité est donnée aux comptes non enregistrés imposables, les retraits du compte d'épargne libre d'impôt (CELI) étant effectués en dernier."
	},
	"disclaimers.copyright" : {
		"en": "Copyright 2024 - Rose & Associates Inc.",
		"fr": "",
	},
	"disclaimers.disclaimers" : {
		"en": "Disclaimers",
		"fr": "Avis de non-responsabilité",
	},
	"disclaimers.legalText" : {
		"en": "Legal Information",
		"fr": "Information légale",
	},
	"disclaimers.privacyText" : {
		"en": "Privacy Policy",
		"fr": "Politique de confidentialité",
	},
	"disclaimers.complaintText" : {
		"en": "How to File a Complaint",
		"fr": "Déposer une plainte",
	},
	"disclaimers.general" : {
		"en": "The contents of this website does not constitute an offer or solicitation for residents in the United States or in any other jurisdiction where either Rose & Associates Inc. and/or Sterling Mutuals Inc. is not registered or permitted to conduct business. Mutual funds provided through Sterling Mutuals Inc. Commissions, trailing commissions, management fees and expenses all may be associated with mutual fund investments. Please read the prospectus carefully before investing. Mutual funds are not guaranteed, their values fluctuate frequently and past performance may not be repeated.",
		"fr": "Le contenu de ce site-web ne constitue ni une offre, ni une solicitation pour les résidents des États-Unis ou de tout autre territoire où Rose & Associates Inc. et/ou Sterling Mutuals Inc. ne sont pas enregistrés ou autorisés à mener des affaires. Les fonds mutuels fournis à travers les commissions de Sterling Mutuals Inc., les commissions de suivis, puis  les frais et dépenses de gestion, peuvent tous être associés à des investissements de fonds mutuels. Veuillez lire attentivement le prospectus avand d'investir. Les fonds mutuels ne sont pas garantis, leur valeur fluctue fréquemment, puis il est possible que leur performance antérieure ne soit pas répétée.",
	},
	"disclaimers.general2" : {
		"en": "Insurance products, and other related financial services are provided by Rose & Associates Inc. as independent insurance agents, and are not the business of, or monitored by Sterling Mutuals Inc.",
		"fr": "Les produits d'assurance, ainsi que les produits financiés connexes, sont fournis par Rose & Associates Inc. en tant qu'agents d'assurance indépendants et ils ne font partie ni des affaires, ni de la surveillance de Sterling Mutuals Inc.",
	},
	"disclaimers.acceptButton" : {
		"en": "Accept Disclaimers",
		"fr": "Accepter les avis de non-responsabilité"
	},


	// Warnings
	"warning.editGPSData" : {
		"en": "You are attempting to edit the data connected with the FinancialGPS. Changing this data could alter the projections withing the GPS. Do you wish to proceed?",
		"fr": "Vous essayez de modifier les données liées à GPS financier. La modification de ces données pourrait modifier les projections faites dans GPS financier. Souhaitez-vous poursuivre?"
	},


	// PDF
	"pdf.preparedOnBehalf" : {
		"en": "prepared on behalf of",
		"fr": "Préparé pour le compte de"
	},
	"pdf.clientProfile" : {
		"en": "Client Profile",
		"fr": "Profil du client"
	},
	"pdf.beneficiary" : {
		"en": "Benefciary",
		"fr": "Bénéficiaire"
	},
	"pdf.executor" : {
		"en": "Executor",
		"fr": "Exécuteur testamentaire"
	},
	"pdf.name" : {
		"en": "Name",
		"fr": "Nom"
	},
	"pdf.age" : {
		"en": "Age",
		"fr": "Âge"
	},
	"pdf.netWorthIntro" : {
		"en": "The Net Worth report provides a snapshot overview of your current financial situation, showing the combined totals in both assets and liabilities.",
		"fr": "Le rapport sur la valeur nette patrimoniale donne un aperçu de votre situation financière actuelle, en montrant les totaux de l'actif et du passif."
	},
	"pdf.retirementPlannerIntro" : {
		"en": "The Retirement Planner report provides an overview of the financial plan developed for you by Rose & Associates. It provides key details about your projected asset growth and retirement income, in order to provide you with a deeper understanding of what your retirement may look like.",
		"fr": "Un budget de risque est un outil offert par Rose & Associates pour aider les clients à gérer les risques et à mieux connaître leurs plans et objectifs. Pour créer votre budget de risque personnalisé, vous devez fournir certaines informations."
	},
	"pdf.incomeRequiredInPassiveRetirement" : {
		"en": "Income Required in \nPassive Retirement",
		"fr": "Revenu requis à \nla retraite passive"
	},
	// "pdf.targetIncomeAtRetirement" : {
	// 	"en": "Target Income at \nRetirement",
	// 	"fr": "% du revenu cible \nà la retraite"
	// },
	"pdf.targetIncomeAtRetirement" : {
		"en": "Projected Income \nat age %s",
		"fr": "% du revenu cible \nprévu à l’âge de %s"
	},
	"pdf.projectedRateOfInflation" : {
		"en": "Projected Rate \nof Inflation",
		"fr": "Taux d'inflation \nprévu"
	},
	"pdf.projectedRateOfReturn" : {
		"en": "Projected Rate \nof Return",
		"fr": "Taux de rendement \nprévu"
	},
	"pdf.currentMaximumCppPayout" : {
		"en": "Current maximum \nCPP payout",
		"fr": "Montant maximal actuel \nde la prestation du RPC"
	},
	"pdf.currentMaximumOasPayout" : {
		"en": "Current maximum \nOAS payout",
		"fr": "Prestations maximales \nactuelles du RPC"
	},
	"pdf.projectedEligibleCppAtAgeOf" : {
		"en": "Projected Eligible \nCPP at age of %s",
		"fr": "Admissibilité prévue aux prestations \ndu RPC à l’âge de %s"
	},
	"pdf.projectedOasAtAgeOf" : {
		"en": "Projected OAS \nat the age of %s",
		"fr": "Prestations prévues de la SV \nà l'âge de %s"
	},
	"pdf.startReceivingPensionAtAge" : {
		"en": "Start receiving \npension at age",
		"fr": "Commencer à recevoir \nune pension à l'âge de"
	},	
	"pdf.regularTitle" : {
		"en": "REGULAR SAVINGS/INVESTMENTS",
		"fr": "ÉPARGNE ET PLACEMENTS RÉGULIERS"
	},
	"pdf.tfsaTitle" : {
		"en": "TAX-FREE SAVINGS ACCOUNT",
		"fr": "COMPTE D'ÉPARGNE LIBRE D'IMPÔT"
	},
	"pdf.registeredTitle" : {
		"en": "REGISTERED INVESTMENTS",
		"fr": "PLACEMENTS ENREGISTRÉS"
	},
	"pdf.dpspTitle" : {
		"en": "GROUP/DPSP",
		"fr": "GROUPE/RPDB"
	},
	"pdf.lockedinTitle" : {
		"en": "LOCKED-IN INVESTMENTS",
		"fr": "PLACEMENTS IMMOBILISÉS"
	},
	"pdf.yes" : {
		"en": "Yes",
		"fr": "Oui"
	},
	"pdf.no" : {
		"en": "No",
		"fr": "Non"
	},
	"pdf.retirementRiskBudgetIntro" : {
		"en": "A risk budget is a tool offered by Rose & Associates to help clients manage risk and be more informed about their plans and goals. To create your personalized risk budget, some information is required.",
		"fr": "Un budget de risque est un outil offert par Rose & Associates pour aider les clients à gérer les risques et à être mieux informés de leurs plans et objectifs. Pour créer votre budget de risque personnalisé, nous avons besoin de quelques informations."
	},
	"pdf.currentValue" : {
		"en": "Current value:",
		"fr": "Valeur actuelle :"
	},
	"pdf.projectWithdrawalIn" : {
		"en": "Projected Withdrawal in %s",
		"fr": "Retrait projeté en %s"
	},
	"pdf.retirementPortfolioAssumption" : {
		"en": "Using these assumptions, we can calculate the annual rate of return your portfolio will need to earn to achieve your retirement and estate goals.",
		"fr": "À l'aide de ces hypothèses, nous pouvons calculer le taux de rendement annuel que votre portefeuille devra générer pour atteindre vos objectifs de retraite et de succession."
	},

	"pdf.clientListHeading" : {
		"en": "List of Active Clients",
		"fr": "",
	},

	"pdf.clientListIntro": {
		"en": "The following list includes all of the active clients currently in the database, listen in alphabetical order from left to right on each row.",
		"fr": "",
	},


	"links.disclaimers" : {
		"en": "http://www.roseassociates.ca/disclaimers/",
		"fr": ""
	},
	"links.legal" : {
		"en": "https://www.sterlingmutuals.com/client/legal.html",
		"fr": ""
	},
	"links.privacy" : {
		"en": "https://www.sterlingmutuals.com/client/privacy.html",
		"fr": ""
	},
	"links.complaint" : {
		"en": "https://www.sterlingmutuals.com/client/complaint.html",
		"fr": ""
	},


}

export default {
  translations,
} // end


// WEBPACK FOOTER //
// ./src/translations/translations.js